import React, {Component, Fragment} from 'react';
import {Route, Routes} from 'react-router-dom'
import {withTranslation} from 'react-i18next';
import {withStyleguide, GelContentContainer, withRouter, NotFound, PageTracking} from "cw-styleguide-react";
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {route} from "./routes";
import LandingController from "./controllers/LandingController";
import JobLandingController from "./controllers/JobLandingController";

class App extends Component {
  componentDidMount() {

    this.props.styleguide.setStaticBreadcrumbs([{to: route('myFuture'), text: this.props.t('misc.myFuture')}]);
  }

  render() {
    return (
      <Fragment>
        <PageTracking />
        <BreadcrumbsItem to={'/'}>
          {this.props.t('app.name')}
        </BreadcrumbsItem>
        <GelContentContainer>
        <Routes>
          <Route  path={route('aboutJobs')} element={<LandingController/>}/>
          <Route path="/:jobid/*" element={<JobLandingController/>}/>
          <Route path="*" element={<GelContentContainer><NotFound/></GelContentContainer>} />
        </Routes>
        </GelContentContainer>
      </Fragment>

    );
  }
}

export default withStyleguide(withRouter(withTranslation('local')(App)));
